import * as React from 'react';

import { DesktopBanner } from '../../components/Leads';

import { trackGoToApplicationForm } from './tracking';

export interface ILeadsContainerProps {
  open: boolean;
  onClose(): void;
}

export const LeadsContainer: React.FC<ILeadsContainerProps> = ({ open, onClose }) => {
  /**
   * Показываем баннер заявок только когда:
   *  - он доступен (open)
   *  - десктопное устройство у пользователя
   */
  if (open) {
    return <DesktopBanner onClick={trackGoToApplicationForm} onClose={onClose} />;
  }

  return null;
};

LeadsContainer.displayName = 'LeadsContainer';
